/**
 * Semmies Haarspeldjes — Variant Dropdown Auto-Close
 *
 * Zorgt ervoor dat de variant dropdown op productpagina's
 * automatisch sluit zodra de klant een optie heeft gekozen.
 *
 * Werkt op alle productpagina's zonder andere functionaliteit
 * te beïnvloeden.
 */
(function () {
  'use strict';

  function closeDropdown(detailsEl) {
    if (!detailsEl) return;
    detailsEl.removeAttribute('open');
    var summary = detailsEl.querySelector('summary');
    if (summary) summary.removeAttribute('aria-expanded');
  }

  /**
   * Capture-fase listener: vuurt vóór bestaande bubble-handlers.
   * setTimeout geeft de bestaande handlers tijd om te voltooien,
   * daarna sluiten we de dropdown definitief.
   */
  document.addEventListener('click', function (e) {
    // Alleen reageren op klikken binnen een variant-dropdown
    var selectorItem = e.target.closest(
      'variant-selects .selector-item, .product-form__input--dropdown .selector-item'
    );
    if (!selectorItem) return;

    var details = selectorItem.closest('details');
    if (!details) return;

    // Sluit na bestaande handlers (incl. onVariantChange fetch)
    setTimeout(function () {
      closeDropdown(details);
    }, 50);
  }, true); // true = capture-fase

})();
